<script setup lang="ts">
import { onMounted, toRefs,watch,reactive, ref,onBeforeUnmount,computed } from "vue";
import { errorAlert } from "../plugins/alert";
import CustomList from "./CustomList.vue";
import CustomEvent from "./CustomEvent.vue";
import TextBox from "./TextBox.vue";
import { deepCopy,getLargestZIndex } from "../plugins/utility";


const props = defineProps({
    value: {
      type:[Number,String,Array],
      required:true
    },
    identityId: {
      type:Number,
      default: () => {
        return 0;
      }
    },
    options: {
      type:Array,
      default: () => {
          return [];
      }
    },
    apiUrl: {
      type:String,
      default: () => {
          return '';
      }
    },
    apiOptionFields: {
      type: Object,
      default: () => {
        return null;
      }
    },
    listIdName: {
      type:String,
      default: () => {
          return 'id';
      }
    },
    width: {
      type:String,
      default: () => {
          return '100%';
      }
    },
    isSearchable: {
      type:Boolean,
      default: () => {
          return true;
      }
    },
    isReadOnly: {
      type:Boolean,
      default: () => {
          return false;
      }
    },
    isMulti: {
      type:Boolean,
      default: () => {
          return false;
      }
    },
    isHoverPopup: {
      type:Boolean,
      default: () => {
        return false;
      }
    },
    listFieldName: {
      type:String,
      default: () => {
          return 'name';
      }
    },
    listFieldNameOption: {
      type:String,
      default: () => {
          return '';
      }
    },
    listHeight: {
      type:String,
      default: () => {
          return '6.5em';
      }
    },
    onChange: {
      type:Function,
    },
    onChangeObject: {
      type:Function,
    },
    fontSize: {
      type:String,
      default: () => {
        return '';
      }
    },
    fontLineHeight: {
      type:String,
      default: () => {
        return '';
      }
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    },
    valueOptions:{
      type:Object,
      default: () => {
        return null;
      }
    }
})

const { value,options,identityId,apiOptionFields } = toRefs(props);

const listRef = ref();
const inputRef = ref();
const zIndex = ref(10);
const selectedItemHolder = ref('');
const selectId = ref(props.value);
const listBoxTop = ref(0);
const expandButtonElement = ref();
const viewPortHeight = ref(0);
const listBoxLeft = ref(0);
const listBoxWidth = ref(0);
const isOpen = ref(false);
const isSearching = ref(false);
const selectText = ref("");
const optionFields = (props.apiOptionFields != null ? reactive(deepCopy(props.apiOptionFields)) : reactive({}));
optionFields.search_word = selectText.value;
optionFields.exclude_ids = [];
optionFields.exclude_id_name = props.listIdName;
const selectOptions = reactive(deepCopy(props.options));

const setSelectedItemHolder = (values) => {
  selectedItemHolder.value = '';
  if (props.isMulti == false) {
    return;
  }
  let selectedItemNames = [];
  for (let i=0;i<values.length;i++) {
    let item = listRef.value.getItemById(values[i]);
    if (item != null) {
      selectedItemNames.push(item[props.listFieldName]);
    }
  }
  if (selectedItemNames.length > 0) {
    selectedItemHolder.value = selectedItemNames.join(",");
  }
  selectText.value = '';
}
const listSelected = (item:Object) => {
  if (props.isMulti) {
    let exists = false;
    for (let i=0;i<selectId.value.length;i++) {
      if (selectId.value[i] == item[props.listIdName]) {
        exists = true;
        selectId.value.splice(i,1);
        break;
      }
    }
    if (exists == false) {
      selectId.value.push(item[props.listIdName]);
    }
    setSelectedItemHolder(selectId.value);
    if (typeof props.onChange !== 'undefined') {
      if (props.valueOptions !== null) {
        props.onChange(deepCopy(selectId.value),deepCopy(selectText.value),deepCopy(props.valueOptions));
      } else {
        props.onChange(deepCopy(selectId.value),deepCopy(selectText.value));
      }
    }
    if (typeof props.onChangeObject !== 'undefined') {
      let itemObject = listRef.value.getItemById(item[props.listIdName]);
      if (props.valueOptions !== null) {
        props.onChangeObject(deepCopy(itemObject),deepCopy(selectText.value),deepCopy(props.valueOptions));
      } else {
        props.onChangeObject(deepCopy(itemObject),deepCopy(selectText.value));
      }
    }
    updateSelectOptions(deepCopy(selectId.value));
    return;
  }
  selectId.value = item[props.listIdName];
  selectText.value = item[props.listFieldName];
  //デフォルトに追加する
  let exists = false;
  for (let i=0;i<selectOptions.length;i++) {
    if (selectOptions[i][props.listIdName] == selectId.value) {
      exists = true;
      break;
    }
  }
  if (exists == false) {
    let optionRecord = {}
    optionRecord[props.listIdName] = selectId.value;
    optionRecord[props.listFieldName] = selectText.value;
    selectOptions.push(optionRecord);
  }
  //リストの初期化
  listSearch();

  isOpen.value = false;
  if (typeof props.onChange !== 'undefined') {
    if (props.valueOptions !== null) {
      props.onChange(selectId.value,selectText.value,props.valueOptions);
    } else {
      props.onChange(selectId.value,selectText.value);
    }
  }
  if (typeof props.onChangeObject !== 'undefined') {
    if (props.valueOptions !== null) {
      props.onChangeObject(deepCopy(item),deepCopy(selectText.value),deepCopy(props.valueOptions));
    } else {
      props.onChangeObject(deepCopy(item),deepCopy(selectText.value));
    }
  }
}

const listSearch = () => {
  optionFields.exclude_ids = [];
  let options = getSelectOptions();
  for (let i=0;i<options.length;i++) {
    if (!options[i][props.listFieldName]) {
      continue;
    }
    optionFields.exclude_ids.push(options[i][props.listIdName]);
  }
  if (props.apiOptionFields != null && typeof props.apiOptionFields.exclude_ids !== 'undefined') {
    for (let i=0;i<props.apiOptionFields.exclude_ids.length;i++) {
      optionFields.exclude_ids.push(props.apiOptionFields.exclude_ids[i]);
    }
  }

  if (typeof listRef.value !== 'undefined') {
    listRef.value.resetItem();
  }
}
const initializeOptions = () => {
  listSearch();
  initialValues();
}
const initialValues = () => {
  for (let i=0;i<selectOptions.length;i++) {
    if (selectId.value == selectOptions[i][props.listIdName]) {
      selectText.value = selectOptions[i][props.listFieldName];
      break;
    }
  }
}
const refleshSelectValue = () => {
  for (let i=0;i<selectOptions.length;i++) {
    if (selectOptions[i][props.listIdName] == selectId.value) {
      selectText.value = selectOptions[i][props.listFieldName];
      break;
    }
  }
}
const selectSearchClear = () => {
  if (isOpen.value) {
    isSearching.value = false;
    isClosing.value = true;
    isOpen.value = false;
  }
}
const onSelectTextChange = (value) => {
  selectText.value = value;
}
const onSelectTextEnter = (value) => {
  selectText.value = value;
  if (isOpen.value) {
    optionFields.search_word = selectText.value;
    listSearch();
  }
}
const onSelectTextFocus = (value) => {
  if (props.isReadOnly) {
    isOpen.value = false;
    return;
  }
  if (props.isSearchable == false) {
    //検索しない場合はこのフォーカスで開閉する
    isOpen.value = !isOpen.value;
    inputRef.value.leaveFocus();
  } else {
    isOpen.value = true;
    isSearching.value = true;
    selectText.value = value;
    optionFields.search_word = selectText.value;
  }
}
const onSelectClick = (e) => {
  if (props.isReadOnly) {
    isOpen.value = false;
    return;
  }
  if (isOpen.value == true && inputRef.value.isEdited()) {
    inputRef.value.changeCancel();
  }
  if (isOpen.value == false && props.isMulti) {
    selectText.value = '';
  }
  isOpen.value = !isOpen.value;
}
const selectSearchReset = () => {
  //
}
const listBoxSetPosition = () => {
  let rect = element.value.getBoundingClientRect();
  listBoxTop.value = rect.top + element.value.clientHeight + visualViewport.offsetTop - viewPortHeight.value;
  listBoxLeft.value = rect.left;
  let buttonRect = expandButtonElement.value.getBoundingClientRect();
  listBoxWidth.value = rect.width - buttonRect.width;
}
watch(value,(newValue, oldValue) => {
  if ((props.isMulti == false) && (newValue != selectId.value)) {
    selectId.value = newValue;
    selectText.value = '';
    refleshSelectValue();
  }
},{deep:true})
watch(identityId,(newValue,oldValue) => {
  selectOptions.splice(0);
  selectText.value = '';
  refleshSelectValue();
})
watch(isOpen,(newValue, oldValue) => {
  if (newValue) {
    //elementの最大z-indexを取得してそれより大きくする
    zIndex.value = getLargestZIndex();
    if (props.isMulti) {
      //複数選択の場合は条件はリセットする
      selectText.value = '';
      optionFields.search_word = selectText.value;
    }
    listReposition();
    initializeOptions(props.options);
  } else {
    if (props.isMulti) {
      //複数選択の場合は条件はリセットする
      selectText.value = '';
    }
    optionFields.search_word = '';
    isSearching.value = false;
  }
})
watch(options,(newValue, oldValue) => {
  selectOptions.splice(0);
  for (let i=0;i<newValue.length;i++) {
    selectOptions.push(newValue[i]);
  }
  if (!props.isMulti) {
    initializeOptions();
  }
},{deep:true})
watch(apiOptionFields,(newValue, oldValue) => {
  for (let key in newValue) {
    if (Array.isArray(newValue[key])) {
      optionFields[key].splice(0);
      for (let i=0;i<newValue[key].length;i++) {
        optionFields[key].push(newValue[key][i]);
      }
    } else {
      optionFields[key] = newValue[key];
    }
  }
},{deep:true});
const {element,isClosing,clickOutside} = CustomEvent(selectSearchClear)

const listReposition = () => {
  setTimeout(listBoxSetPosition,300);
}
const windowResize = () => {
  listReposition();
}
const viewPortResize = () => {
  listReposition();
}
const windowScroll = () => {
  //listReposition();
}
onBeforeUnmount(() => {
  window.removeEventListener('click', clickOutside);
  window.removeEventListener('resize', windowResize);
  window.removeEventListener('scroll', windowScroll);
  visualViewport.removeEventListener("resize",viewPortResize);
});
onMounted(() => {
  initialValues();
  window.addEventListener('click', clickOutside);
  window.addEventListener('resize', windowResize);
  window.addEventListener('scroll', windowScroll);
  visualViewport.addEventListener("resize",viewPortResize);
});
const getSelectOptions = () => {
  let result = [];
  if (!isSearching.value || (isSearching.value && !selectText.value)) {
    for (let i=0;i<selectOptions.length;i++) {
      result.push(selectOptions[i]);
    }
  }
  return result;
}
const updateSelectOptions = (values) => {
  //不足しているものを追加する
  for (let i=0;i<values.length;i++) {
    let exists = false;
    for (let j=0;j<selectOptions.length;j++) {
      if (values[i] == selectOptions[j][props.listIdName]) {
        exists = true;
        break;
      }
    }
    if (exists == false) {
      let items = listRef.value.getItems();
      for (let j=0;j<items.length;j++) {
        if (items[j][props.listIdName] == values[i]) {
          let record = {}
          record[props.listIdName] = items[j][props.listIdName];
          record[props.listFieldName] = getFieldName(items[j]);
          selectOptions.push(record);
          break;
        }
      }
    }
  }
}
const selectOptionList = computed(() => {
  return getSelectOptions();
})
const onCheckChange = (values) => {
  setSelectedItemHolder(values);
  props.onChange(values);
  updateSelectOptions(values);
}
const getFieldName = (item) => {
  let result = item[props.listFieldName];
  if (props.listFieldNameOption.length > 0 && typeof item[props.listFieldNameOption] !== 'undefined' && item[props.listFieldNameOption].length > 0) {
    result += '<span style="margin: 1.0em;background: #f00;color: white;border-radius: 0.8em;padding: 0.2em;">' + item[props.listFieldNameOption] + '</span>';
  }
  return result;
}
</script>

<style scoped>
</style>

<template>
  <div ref="element" class="flex rounded-md shadow-sm w-full relative">
    <div class="w-full flex">
      <text-box
        ref="inputRef"
        :value="selectText"
        type="text"
        :font-size="fontSize"
        :font-line-height="fontLineHeight"
        :is-no-rounded-right="true"
        :is-hover-popup="isHoverPopup"
        :width="width"
        :is-focus-clear="isSearchable"
        :is-read-only="isReadOnly"
        :is-text-fixed="!isSearchable"
        :is-enter-key-hint="true"
        :on-change="onSelectTextChange"
        :on-enter="onSelectTextEnter"
        :on-focus="onSelectTextFocus"
        :on-clear="selectSearchClear"
        :place-holder="placeHolder"
        :selected-item-holder="selectedItemHolder"
      ></text-box>
      <span ref="expandButtonElement" v-show="isOpen" @click="onSelectClick" class="cursor-pointer flex w-2.5 items-center justify-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-500"><i class="fa-solid fa-chevron-up"></i></span>
      <span v-show="!isOpen" @click="onSelectClick" class="cursor-pointer flex w-2.5 items-center justify-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-500"><i class="fa-solid fa-chevron-down"></i></span>
    </div>
    <div v-show="isOpen" class="fixed" :style="'top:' + listBoxTop + 'px;left:' + listBoxLeft + 'px;width:' + listBoxWidth + 'px;z-index:' + zIndex + ';'">
      <custom-list
        ref="listRef"
        :default-values="selectOptionList"
        :is-searchable="false"
        :api-url="apiUrl"
        :option-fields="optionFields"
        :reset="selectSearchReset"
        :list-key="listIdName"
        :is-checkable="isMulti"
        :is-all-check="false"
        :check-values="selectId"
        width="w-full"
        :font-size="fontSize"
        :z-index="200"
        :height="listHeight"
        :on-check-change="onCheckChange"
      >
      <template v-slot:item="slotProps">
        <span class="w-full block" @click="listSelected(slotProps.item)" v-html="(getFieldName(slotProps.item))"></span>
      </template>
      </custom-list>
    </div>
  </div>
</template>

